<template>
  <section>
    <!--工具条-->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
    >
      <el-form-item label="学员姓名">
        <el-input v-model="filters.MemberName" placeholder="请输入学员姓名"></el-input>
      </el-form-item>
      <el-form-item label="收件人">
        <el-input v-model="filters.ReceiverName" placeholder="请输入收件人"></el-input>
      </el-form-item>
      <el-form-item label="快递单号">
        <el-input v-model="filters.ExpressNo" placeholder="请输入快递单号"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.DeliveryStatus" clearable placeholder="请选择状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="待填写地址" :value="1"></el-option>
          <el-option label="待发货" :value="2"></el-option>
          <el-option label="已发货" :value="3"></el-option>
          <el-option label="已签收" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button
          :type="item.Func && item.Func.toLowerCase().indexOf('export') != -1 ? 'success' : 'primary'"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="Id" label="ID" width="60"></el-table-column>
      <el-table-column prop="MemberName" label="学员姓名" width="100"></el-table-column>
      <el-table-column prop="CertificateName" label="证书名称" width="150"></el-table-column>
      <el-table-column prop="ReceiverName" label="收件人" width="100"></el-table-column>
      <el-table-column prop="ReceiverPhone" label="联系电话" width="120"></el-table-column>
      <el-table-column prop="FullAddress" label="收货地址" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column prop="ExpressCompany" label="快递公司" width="100"></el-table-column>
      <el-table-column prop="ExpressNo" label="快递单号" width="150"></el-table-column>
      <el-table-column prop="DeliveryStatusName" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.DeliveryStatus)" size="small">
            {{ scope.row.DeliveryStatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ShipTime" label="发货时间" width="160" :formatter="formatTime"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="160" :formatter="formatCreateTime"></el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--发货弹窗-->
    <el-dialog
      title="发货"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="shipForm" :rules="shipFormRules" ref="shipForm" label-width="100px">
        <el-form-item label="收件人">
          <span>{{ currentRow ? currentRow.ReceiverName : '' }}</span>
        </el-form-item>
        <el-form-item label="联系电话">
          <span>{{ currentRow ? currentRow.ReceiverPhone : '' }}</span>
        </el-form-item>
        <el-form-item label="收货地址">
          <span>{{ currentRow ? currentRow.FullAddress : '' }}</span>
        </el-form-item>
        <el-form-item label="快递公司" prop="ExpressCompany">
          <el-select v-model="shipForm.ExpressCompany" placeholder="请选择快递公司" style="width: 100%">
            <el-option label="顺丰速运" value="顺丰速运"></el-option>
            <el-option label="中通快递" value="中通快递"></el-option>
            <el-option label="圆通速递" value="圆通速递"></el-option>
            <el-option label="韵达快递" value="韵达快递"></el-option>
            <el-option label="申通快递" value="申通快递"></el-option>
            <el-option label="EMS" value="EMS"></el-option>
            <el-option label="京东物流" value="京东物流"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="ExpressNo">
          <el-input v-model="shipForm.ExpressNo" placeholder="请输入快递单号"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="shipForm.Remark" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitShip" :loading="submitLoading">确认发货</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  CertificateDeliveryGetList,
  CertificateDeliveryUpdate,
  CertificateDeliveryExport,
} from '../../api/api'
import { formatDate } from '../../common/js/date'

export default {
  data() {
    return {
      filters: {
        MemberName: '',
        ReceiverName: '',
        ExpressNo: '',
        DeliveryStatus: -1,
      },
      tableData: [],
      listLoading: false,
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      currentRow: null,
      buttonList: [],

      dialogVisible: false,
      submitLoading: false,
      shipForm: {
        Id: 0,
        ExpressCompany: '',
        ExpressNo: '',
        Remark: '',
      },
      shipFormRules: {
        ExpressCompany: [{ required: true, message: '请选择快递公司', trigger: 'change' }],
        ExpressNo: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.getModules_search()
  },
  methods: {
    callFunc(item) {
      this[item.Func](item)
    },
    async getModules_search() {
      this.listLoading = true
      const { data } = await CertificateDeliveryGetList({
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        MemberName: this.filters.MemberName,
        ReceiverName: this.filters.ReceiverName,
        ExpressNo: this.filters.ExpressNo,
        DeliveryStatus: this.filters.DeliveryStatus,
      })
      if (data.success) {
        this.tableData = data.response.data
        this.total = data.response.dataCount
        this.buttonList = data.response.buttonList || this.buttonList
        if (this.buttonList.length === 0) {
          this.buttonList = [
            { id: 1, name: '查询', Func: 'getModules_search' },
            { id: 2, name: '发货', Func: 'handleShip' },
            { id: 3, name: '导出', Func: 'handleExport' },
          ]
        }
      }
      this.listLoading = false
    },
    selectCurrentRow(row) {
      this.currentRow = row
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getModules_search()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getModules_search()
    },
    handleShip() {
      if (!this.currentRow) {
        this.$message.warning('请选择要发货的记录')
        return
      }
      if (this.currentRow.DeliveryStatus !== 2) {
        this.$message.warning('只有待发货状态才能发货')
        return
      }
      this.shipForm = {
        Id: this.currentRow.Id,
        ExpressCompany: '',
        ExpressNo: '',
        Remark: '',
      }
      this.dialogVisible = true
    },
    async handleExport() {
      this.$message.info('导出功能开发中...')
    },
    async submitShip() {
      this.$refs.shipForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          const { data } = await CertificateDeliveryUpdate(this.shipForm)
          this.submitLoading = false
          if (data.success) {
            this.$message.success('发货成功')
            this.dialogVisible = false
            this.getModules_search()
          } else {
            this.$message.error(data.msg)
          }
        }
      })
    },
    getStatusType(status) {
      const types = {
        1: 'warning',
        2: 'info',
        3: 'primary',
        4: 'success',
      }
      return types[status] || 'info'
    },
    formatTime(row) {
      if (!row.ShipTime) return '-'
      return formatDate(new Date(row.ShipTime), 'yyyy-MM-dd hh:mm')
    },
    formatCreateTime(row) {
      if (!row.CreateTime) return ''
      return formatDate(new Date(row.CreateTime), 'yyyy-MM-dd hh:mm')
    },
  },
}
</script>

<style scoped>
</style>
